import Share from 'ninelines-sharing';
import {getResult} from './components/test';

$('.test-inc-share__item').on('click', (e) => {
	const social = $(e.currentTarget).data('social');
	let url = location.origin;

	url += `/share.php?result=${getResult()}`;

	Share[social](url);
});
